
<template>
    <div class="entrance-page">
        <div class="main-box">
            <ClientOnly>
                <div class="cell"
                    v-for="(oHall, idx) of aHalls"
                    :key="idx"
                >
                    <HallCover
                        :info="oHall"
                        :hallNumber="oHall.intLevel"
                        :disabled="oHall.disabled"
                        @click="fnGoIntoOneHall(oHall)"
                    />
                </div>
            </ClientOnly>
        </div>

        <footer class="footer-bar">
            <ButtonThe3DButton
                class=""
                @click="goIntoRandomly()"
                size="lg"
                color="red"
            >
                {{ $t('redPacketMines.quickJoin') }}
            </ButtonThe3DButton>
        </footer>
    </div>
    <!--
        ↓ 历史“详情” 窗口，在此监听 route 参数变化并打开
        ↓ 主要服务于从管理员的后台界面进入的情况，后面管理员界面的数据没有厅 id，所以跳到入口页打开游戏历史 
    -->
    <CasinoHistoryModalGameDetali
        :gameDropValue="'redpacket'"
    />
</template>


<script lang="ts">
import {toCloseLoading} from '@/layouts/gameCoat/ts/gameCoat'; 
import HallCover from '../_components/hallCover.vue';
import { useJoinStateStore } from '@/stores/cansino/joinState'; 
import { getHallsList, fnGoIntoOneHall }  from '~/pages/casino/redpacketGame/ts/redPacketCommon';
import { useGameSocket } from '@/socket/game'; 

export default defineComponent({ 
    name: 'redPacketMinesGameEntrance',
    components: {
        HallCover,
    },
    data(){
        return {
            joinStateStore: useJoinStateStore(),
        };
    },
    computed:{
        aHalls: getHallsList,
    },
    created(){
        
    },
    mounted(){
        toCloseLoading();
        // ↓ 进入大厅时调用 join 接口，参数传空
        // ↓ 这样当用户进入红包游戏大厅时，会调用 games.redpacket.join 接口通知服务器，服务器会将该用户标记为"在游戏中"。
        // ↓ 如果同一账号在其他窗口打开同一游戏，服务器就会向旧窗口发送 log_off code 8888 事件。
        const { EMIT_GAME_JOIN } = useGameSocket();
        EMIT_GAME_JOIN('redpacket', {}, (res) => {
            console.log('redpacket entrance join:', res);
        });
    },
    beforeUnmount(){
        // ↓ 离开大厅时调用 exit 接口，通知服务器用户已离开游戏
        const { EMIT_GAME_EXIT } = useGameSocket();
        EMIT_GAME_EXIT('redpacket');
    },
    methods:{
        fnGoIntoOneHall,
        goIntoRandomly(){
            // 按余额找出有权限的厅，然后随机进入 
            const oHall = this.aHalls.filter((cur, idx)=>{
                return cur.disabled == false;
            }).find((cur, idx, arr)=>{
                console.log('arr', arr); 
                const bResult = (
                    (Math.random() > 0.5)
                    || (idx === arr.length - 1)
                );
                return bResult;
            });
            if (!oHall) {
                return showNegativeNotify({
                    i18n: 'amountTips.noMoneyPleaseCharge',
                });
            }
            this.fnGoIntoOneHall(oHall);
        },
    },
});

</script>


<style scoped lang="scss" >
.entrance-page{
    max-width: 500px;
    margin: 0 auto; 
    height: calc(100vh - var(--header-heigh));
    max-height: calc(100vh - var(--header-heigh)); 
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    background-image: url(../img/bg-entrance.webp);
    background-size: cover;
    background-position: center; 
    overflow-y: auto; 
}

.main-box{
    width: 100%; 
    margin: 0 auto; 
    padding: 20px ; 
    display: grid;    
    grid-template-columns: repeat(2, 1fr);
    row-gap: 20px;
    column-gap: 35px;
    flex: 1; 
}

.cell{
    // max-height: calc(100vh / 5); 
    &:nth-child(1),
    &:nth-child(4){
        .hall-cover{
            margin-left: auto; 
        }
    }
    &:nth-child(3){
        grid-column-start: 1;
        grid-column-end: 3;
        .hall-cover{
            margin: 0 auto; 
            width: calc(50% - 18px);
        }    
    }
    .hall-cover{
        display: flex; 
        // width: 150px; 
    }
}

@media screen and (max-width: 375px){
    .main-box{
        row-gap: 15px;
        column-gap: 30px;
    }
    .cell{
        .hall-cover{
            width: 140px;
        }
    }
}

@media screen and (max-width: 360px){
    .main-box{
        row-gap: 10px;
        column-gap: 25px;
    }
    .cell{
        .hall-cover{
            width: 110px;
        }
    }
}

.footer-bar{
    flex: 0 0 auto; 
    width: 100%; 
    .button-3d{
        display: block; 
        margin: 0 auto; 
        width: calc(100% - 50px); 
    }
}
</style>


